<template>
  <div class="basic-image-container">
    <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
      <star-condition-cell label="模板类型">
        <a-select allowClear v-model="searchCondition.templateType" style="width: 100%">
          <a-select-option value="滚动翻页">滚动翻页</a-select-option>
          <a-select-option value="下一页翻页">下一页翻页</a-select-option>
          <a-select-option value="点击加载翻页">点击加载翻页</a-select-option>
          <a-select-option value="数字翻页">数字翻页</a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="模板状态">
        <a-select allowClear v-model="searchCondition.templateStatus" style="width: 100%">
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">停用</a-select-option>
        </a-select>
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" @click="isShowCreateModal = true">
          <a-icon type="plus"></a-icon>
          新建
        </a-button>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="dbRedisId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="templateStatus" slot-scope="text, record">
          <a-badge v-if="record.templateStatus === 1" color="blue" text="运行中"> </a-badge>
          <a-badge
            v-if="record.templateStatus === -1"
            color="rgba(0,0,0,0.4)"
            text="已停用"
          ></a-badge>
          <a-badge v-if="record.templateStatus === 0" color="gold" text="未启用"></a-badge>
        </span>

        <span slot="openBrowser" slot-scope="text, record">{{
          record.openBrowser === 0 ? '否' : '是'
        }}</span>

        <span slot="templateStatus" slot-scope="text, record">{{
          record.templateStatus === 0 ? '停用' : '使用中'
        }}</span>

        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="showModifyImageModal(record)">编辑</a-button>
          <a-divider type="vertical" />
          <a-button type="link" v-if="record.templateStatus === 1" @click="onClose(record)"
            >停用</a-button
          >
          <a-button type="link" v-if="record.templateStatus === 0" @click="onOpen(record)"
            >启用</a-button
          >

          <!-- <a-divider type="vertical" /> -->
          <!-- <a-popconfirm title="确定要删除吗?" @confirm="() => onDeleteDatabase(record)">
            <a-button type="link">删除</a-button>
          </a-popconfirm> -->
        </span>
      </a-table>
    </div>

    <a-modal
      v-model="isShowCreateModal"
      title="新建模板"
      @cancel="handleCancel"
      @ok="onSubmitNewDataBase"
    >
      <a-form-model
        ref="ruleForm"
        :model="newDataBase"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-form-model-item ref="templateType" label="模板类型" prop="templateType">
          <a-select v-model="newDataBase.templateType">
            <a-select-option value="滚动翻页">滚动翻页</a-select-option>
            <a-select-option value="下一页翻页">下一页翻页</a-select-option>
            <a-select-option value="点击加载翻页">点击加载翻页</a-select-option>
            <a-select-option value="数字翻页">数字翻页</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="openBrowser" label="需要开启浏览器" prop="openBrowser">
          <a-switch
            @change="
              () => {
                newDataBase.openBrowser === 1
                  ? (newDataBase.openBrowser = 0)
                  : (newDataBase.openBrowser = 1)
              }
            "
            :checked="newDataBase.openBrowser === 1"
          />
        </a-form-model-item>

        <a-form-model-item ref="paramType" label="参数类型" prop="paramType">
          <a-select v-model="newDataBase.paramType">
            <a-select-option value="xpath">xpath</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="defaultParam" label="默认参数" prop="defaultParam">
          <!-- <a-input-number
            :min="0"
            :max="15"
            v-model="newDataBase.defaultParam"
            style="width: 100%"
          /> -->
          <a-input v-model="newDataBase.defaultParam" />
        </a-form-model-item>

        <a-form-model-item ref="templateStatus" label="是否启用" prop="templateStatus">
          <a-switch
            @change="
              () => {
                newDataBase.templateStatus === 1
                  ? (newDataBase.templateStatus = 0)
                  : (newDataBase.templateStatus = 1)
              }
            "
            :checked="newDataBase.templateStatus === 1"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="isShowModifyModal" title="修改模板" @ok="onSubmitModifyDatabase">
      <a-form-model
        ref="ruleFormModify"
        :model="modifyDataBase"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-form-model-item ref="templateType" label="模板类型" prop="templateType">
          <a-select v-model="modifyDataBase.templateType">
            <a-select-option value="滚动翻页">滚动翻页</a-select-option>
            <a-select-option value="下一页翻页">下一页翻页</a-select-option>
            <a-select-option value="点击加载翻页">点击加载翻页</a-select-option>
            <a-select-option value="数字翻页">数字翻页</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="openBrowser" label="需要开启浏览器" prop="openBrowser">
          <a-switch
            @change="
              () => {
                modifyDataBase.openBrowser === 1
                  ? (modifyDataBase.openBrowser = 0)
                  : (modifyDataBase.openBrowser = 1)
              }
            "
            :checked="modifyDataBase.openBrowser === 1"
          />
        </a-form-model-item>

        <a-form-model-item ref="paramType" label="参数类型" prop="paramType">
          <a-select v-model="modifyDataBase.paramType">
            <a-select-option value="xpath">xpath</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="defaultParam" label="默认参数" prop="defaultParam">
          <!-- <a-input-number
            :min="0"
            :max="15"
            v-model="newDataBase.defaultParam"
            style="width: 100%"
          /> -->
          <a-input v-model="modifyDataBase.defaultParam" />
        </a-form-model-item>

        <a-form-model-item ref="templateStatus" label="是否启用" prop="templateStatus">
          <a-switch
            @change="
              () => {
                modifyDataBase.templateStatus === 1
                  ? (modifyDataBase.templateStatus = 0)
                  : (modifyDataBase.templateStatus = 1)
              }
            "
            :checked="modifyDataBase.templateStatus === 1"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- <a-modal
      v-model="isShowSelectNewDatabaseModal"
      title="数据库替换"
      @ok="onChangeDatabase"
      :confirm-loading="modalSubmitloading"
    >
      <p>选择替换的数据库:</p>

      <a-select v-model="willOpenDatabaseId" style="width: 100%">
        <a-select-option
          v-for="item in notOpenDatabaseList"
          :key="item.dbRedisId"
          :value="item.dbRedisId"
          >{{ item.dbRedisName }}
        </a-select-option>
      </a-select>
    </a-modal> -->
  </div>
</template>

<script>
import {
  getDatabaseListApi,
  getAllDatabaseNotOpenListApi,
  createDatabaseApi,
  modifyDatabaseApi,
  modifyDatabaseStatusApi,
  deleteDatabaseApi
} from '@/api/System/Database'
import { getList, createItem, updateItem, queryItem, updateStatus } from '@/api/System/Paging'
import { onHttpResponse, onHttpResponseSilent } from '@/utils/request'
import TableHeadIcons from '@/components/TableHeadIcons'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

export default {
  components: { TableHeadIcons },
  mixins: [tableSettingToStoreMixin()],

  data() {
    return {
      searchCondition: {
        templateStatus: '',
        templateType: ''
      },

      spiderClassOptions: [],
      tableData: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '模板类型',
          dataIndex: 'templateType',
          align: 'center',
          show: true
        },
        {
          title: '参数类型',
          dataIndex: 'paramType',
          align: 'center',
          show: true
        },
        {
          title: '默认参数',
          dataIndex: 'defaultParam',
          align: 'center',
          show: true
        },
        {
          title: '是否要打开浏览器',
          dataIndex: 'openBrowser',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'openBrowser' }
        },
        {
          title: '模板状态',
          dataIndex: 'templateStatus',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'templateStatus' }
        },
        {
          title: '创建人员',
          align: 'center',
          dataIndex: 'createUserName',
          show: true
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          show: true
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 180,
          align: 'center'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      loading: false,
      tableDensity: 'middle',
      isShowColFilterOverlay: false,

      isShowCreateModal: false,
      newDataBase: {
        templateType: '',
        paramType: '',
        defaultParam: '',
        openBrowser: 0,
        templateStatus: 0
      },

      isShowModifyModal: false,
      modifyDataBase: {},

      rules: {
        templateType: { required: true, message: '模板类型为必填项', trigger: 'blur' },
        paramType: { required: true, message: '参数类型为必填项', trigger: 'blur' }
      },

      notOpenDatabaseList: [],

      isShowSelectNewDatabaseModal: false,
      willCloseDatabaseId: 0,
      willOpenDatabaseId: '',

      modalSubmitloading: false
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      this.pagination.current = 1
      this.getDatabaseList()
    },

    reset() {
      this.searchCondition = {
        templateStatus: '',
        templateType: ''
      }
      this.handleSearch()
    },

    onTableDensityChange(density) {
      this.tableDensity = density
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getDatabaseList()
    },

    getDatabaseList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchCondition
      }
      this.loading = true
      getList(query)
        .then(onHttpResponseSilent)
        .then((res) => {
          let { code, msg, data, extra } = res
          if (code === 200) {
            this.tableData = data
            this.pagination.total = extra.page.pageCount || 0
          } else {
            this.$message.error(msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    getClassNameById(record) {
      return (
        this.spiderClassOptions.filter((o) => o.spiderClassId === record.spiderClassId)[0]
          ?.spiderClassName || '未知'
      )
    },
    handleCancel() {
      this.$refs.ruleForm.resetFields()
    },
    onSubmitNewDataBase() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          createItem(this.newDataBase)
            .then(onHttpResponse)
            .then(() => {
              this.newDataBase = {
                templateType: '',
                paramType: '',
                defaultParam: '',
                openBrowser: 0,
                templateStatus: 0
              }
              this.isShowCreateModal = false
              this.handleSearch()
            })
            .catch(() => {})
        }

        return valid
      })
    },

    showModifyImageModal(record) {
      // if (record.templateStatus === 1) {
      //   this.$warning({
      //     title: '运行中的镜像不可编辑',
      //     content: ''
      //   })
      //   return
      // }
      this.modifyDataBase = {
        ...record
      }
      this.isShowModifyModal = true
    },

    onSubmitModifyDatabase() {
      this.$refs.ruleFormModify.validate((valid) => {
        if (valid) {
          updateItem(this.modifyDataBase).then((res) => {
            if (res.code === 200) {
              this.$message.success('修改成功')
              this.isShowModifyModal = false
              this.getDatabaseList()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
        }

        return valid
      })
    },

    onDeleteDatabase(record) {
      if (record.templateStatus === 1) {
        this.$warning({
          content: '运行中的数据库不可删除'
        })
        return
      }

      this.$confirm({
        content: '数据库删除将无法恢复，是否确认删除？',
        onOk: () => {
          return deleteDatabaseApi({ dbRedisId: record.dbRedisId })
            .then(onHttpResponse)
            .then(() => {
              this.getDatabaseList()
              return
            })
            .catch(() => {})
        }
      })
    },

    onClose(record) {
      this.$confirm({
        title: '确认停用',
        content: '是否确认停用？',
        onOk: () => {
          return updateStatus({ spiderPageId: record.spiderPageId, templateStatus: 0 })
            .then(onHttpResponse)
            .then(() => {
              this.getDatabaseList()
              return
            })
            .catch(() => {})
        }
      })
    },

    onOpen(record) {
      this.$confirm({
        title: '确认开启',
        content: '是否确认启用？',
        onOk: () => {
          return updateStatus({ spiderPageId: record.spiderPageId, templateStatus: 1 })
            .then(onHttpResponse)
            .then(() => {
              this.getDatabaseList()
              return
            })
            .catch(() => {})
        }
      })
    },

    onChangeDatabase() {
      if (!this.willOpenDatabaseId) {
        this.$message.warn('请选择替换的数据库')
        return
      }
      this.modalSubmitloading = true

      modifyDatabaseStatusApi({
        dbRedisId: this.willCloseDatabaseId,
        templateStatus: -1,
        newDbRedisId: this.willOpenDatabaseId
      })
        .then(onHttpResponse)
        .then(() => {
          this.getDatabaseList()
          this.isShowSelectNewDatabaseModal = false
          return
        })
        .catch(() => {})
        .finally(() => {
          this.modalSubmitloading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
.basic-image-container {
  width: 100%;
  padding: 16px;

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
</style>
